import { AGENT_NEW_REQUEST } from "./types";

export const agentNewRequest = ({ target: { value } }) => dispatch => {
  dispatch({ type: AGENT_NEW_REQUEST, payload: value.toLowerCase() });
};
